import type IMethodosRepository from '@/core/domain/emethodos/IMethodosRepository.ts'
import EMethodos, { type EMethodosInput } from '@/core/domain/emethodos/EMethodos.ts'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory'
import School from '@/core/domain/school/core/School.ts'

export default class EMethodosRepository implements IMethodosRepository {
  async fetchAllEMethodos(): Promise<EMethodos[]> {
    const response = await apiService.get<EMethodos[]>('e-methodos')
    return response.data.map((res) => EMethodos.create(res))
  }

  async updateEMethodos(input: EMethodosInput): Promise<EMethodos> {
    const response = await apiService.put<School>(`e-methodos/${input.id}`, input)
    return EMethodos.create(response.data)
  }
}
